import Store from "../index";
import { getZatcaInformation } from "../apis/zatca/zatca.api";
import {
  hasZatcaApp,
  isZatcaConfigured,
} from "./zatcaReceiptUtils";

let inflightFetch = null;

export async function fetchAndStoreZatcaMetadata(companyName) {
  if (!companyName) return null;

  if (inflightFetch) {
    return inflightFetch;
  }

  inflightFetch = (async () => {
    try {
      const data = await getZatcaInformation(companyName);
      const vatNumber = data?.vatNumber || data?.taxNumber;
      if (data?.crNumber && vatNumber) {
        Store.dispatch({
          type: "ZATCA_METADATA",
          zatca_metadata: { ...data, vatNumber },
        });
        return { ...data, vatNumber };
      }
      return null;
    } catch {
      return null;
    } finally {
      inflightFetch = null;
    }
  })();

  return inflightFetch;
}

export async function ensureZatcaMetadata(companyName, purchasedApps) {
  const existing = Store.getState()?.zatcaMetaState?.zatca_metadata;
  if (isZatcaConfigured(existing)) {
    return existing;
  }

  if (!hasZatcaApp(purchasedApps) || !companyName) {
    return null;
  }

  return fetchAndStoreZatcaMetadata(companyName);
}
